import { values } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showNotificationAction } from './store/actions';

export { Notifications } from './Notifications';

export const useShowNotification = (initData = {}) => {
    const dispatch = useDispatch();
    const showNotificationCb = (data = {}) => dispatch(showNotificationAction({ ...initData, ...data }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback(showNotificationCb, values(initData));
};
